import BaseUseCase from "../base_use_case.js";
import GwtTokenStorage from "../../utils/gwt_token_storage.js";

class CompleteRegistrationUseCase extends BaseUseCase {

  execute(token, params) {
    let wrappedParams = this.wrapParams(params, "user");
    wrappedParams.confirmationToken = token;
    GwtTokenStorage.clear();
    return this.httpClient({
      ...this.requestConfig(),
      method: "put",
      url: `/api/v1/registrations/complete`,
      data: wrappedParams
    }).then((result) => {
      const { headers: { authorization } } = result;
      GwtTokenStorage.store(authorization);
      return result;
    });
  }
}

const instance = new CompleteRegistrationUseCase();
export default instance;